module.exports = __webpack_public_path__ + "static/img/no-record.1494810e.png";